import { DataSampleType, DataSampleUnit } from "../types";
import { UNIT_BY_TYPE } from "../utils/colors";
import { ApiViewEntry } from "../visuals/SearchControl";

let _view: ApiViewEntry = {
    Id: "",
    Name: "",
    SampleTypeUnitMapping: UNIT_BY_TYPE,
    DefaultStationIdToSelect: "",
    HistPanelConfiguration: {
        ChartRangeHours: [1, 12, 24],
        WindRoseIntervalHours: 1,
        DefaultRangeHours: 24
    },
    NowPanelGrouping: [
        {
            Title: "Last measured values", Elements: [
                { Title: "Wind speed", Element: DataSampleType.WIND_SPEED },
                { Title: "Wind direction", Element: DataSampleType.WIND_DIRECTION },
                { Title: "Gust speed", Element: DataSampleType.WIND_GUST_SPEED },
                { Title: "Gust direction", Element: DataSampleType.WIND_GUST_DIRECTION },
                { Title: "Current speed", Element: DataSampleType.CURRENT_SPEED },
                { Title: "Current direction", Element: DataSampleType.CURRENT_DIRECTION },
                { Title: "Temperature", Element: DataSampleType.AIRTEMP },
                { Title: "Sea Temperature", Element: DataSampleType.SEATEMP },
                { Title: "Relative Humidity", Element: DataSampleType.HUMIDITY },
                { Title: "Pressure at sea level", Element: DataSampleType.PRESSURE_QNH },
                { Title: "Pressure", Element: DataSampleType.PRESSURE_QFE_PO },
                { Title: "Pressure tendency", Element: DataSampleType.PRESSURE_TENDENCY_PP },
                { Title: "Pressure change", Element: DataSampleType.PRESSURE_CHANGE_AA },
                { Title: "Rain", Element: DataSampleType.RAIN_ACCUMULATED }
            ]
        }
    ],
    NorthEast: {
        Latitude: 0,
        Longitude: 0
    },
    SouthWest: {
        Latitude: 0,
        Longitude: 0
    }
}

export function setCurrentView(currentView: ApiViewEntry) {
	_view = currentView;
}

export function getCurrentView(): ApiViewEntry {
	return _view;
}
export function getViewUnit(type: DataSampleType, defaultUnit: DataSampleUnit): DataSampleUnit {
    return _view.SampleTypeUnitMapping?.[type] ?? defaultUnit
}